import { createFileRoute, useNavigate } from '@tanstack/react-router';
import {
  parseProcessorsSearch,
  type ProcessorsSearchPatch,
  withProcessorsSearch,
} from '~portal/components/admin/automations/processors/processor-search';
import { ProcessorsList } from '~portal/components/admin/automations/processors/ProcessorsList';
import { logger } from '~portal/lib';

/**
 * @desc Ario → Processors (round 3, task 4.6). Filters and the open drawer (`?processor=`) live in
 * the URL, so a processor can be linked to (a workflow step's processor, the chat).
 */
export const Route = createFileRoute('/_protected/admin/ario/processors')({
  validateSearch: parseProcessorsSearch,
  component: AutomationProcessorsPage,
});

function AutomationProcessorsPage() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  const update = (patch: ProcessorsSearchPatch) => {
    navigate({
      search: (prev) => withProcessorsSearch(prev, patch),
      // Filters and the drawer change the page in place; keep the list's scroll position.
      resetScroll: false,
    }).catch((err: unknown) => {
      logger.error('[AutomationProcessors] Navigation failed', {
        error: err instanceof Error ? err.message : String(err),
      });
    });
  };

  return <ProcessorsList search={search} onSearch={update} />;
}
